import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "6-expensive-mistakes-that-drive-up-tile-roof-replacement-cost-in-phoenix";
export const Route = createFileRoute("/6-expensive-mistakes-that-drive-up-tile-roof-replacement-cost-in-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
